import { ApolloQueryResult, OperationVariables } from '@apollo/client'
import { IconButton, Typography } from '@material-ui/core'
import RefreshIcon from '@material-ui/icons/Refresh'

import { getTranslate } from '../../../localization'
import { CheckStatus } from '../../../types/checkStatus'
import useStyles from './styles/CheckStatusTableHeader.styles'

interface CheckStatusTableHeaderProps {
  refetch: (variables?: Partial<OperationVariables> | undefined) => Promise<
    ApolloQueryResult<{
      checkStatus: CheckStatus
    }>
  >
}

const CheckStatusTableHeader: React.FC<CheckStatusTableHeaderProps> = ({
  refetch
}) => {
  const classes = useStyles()
  return (
    <div className={classes.root}>
      <div>
        <Typography variant="body1">
          {getTranslate('Room CRS-Number')}
        </Typography>
      </div>
      <div>
        <Typography variant="body1">
          {getTranslate('Room PMS-Number')}
        </Typography>
      </div>
      <div>
        <Typography variant="body1">{getTranslate('PMS Status')}</Typography>
      </div>
      <IconButton onClick={() => refetch()}>
        <RefreshIcon />
      </IconButton>
    </div>
  )
}
export default CheckStatusTableHeader
